module.exports = __webpack_public_path__ + "img/consultancy-overview-2.e57079ff.svg";